import React, { useState } from 'react';
import { MuiThemeProvider } from "@material-ui/core/styles";
import useStyles, { getMuiTheme } from './style';
import { Grid,useTheme,CardContent,Collapse } from "@material-ui/core";
import FormInput from '../../../FormInput';
import { isNumeric, format2Number } from '../calculate';
import clsx from 'clsx';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

export default function LineItemRow({ data, rowNum, onChange, initialValues, view = "editview", module, setIsRowRemoved }) {
    // console.log("LineItemRow initialvalues-->",initialValues);
    const classes = useStyles();
    const theme = useTheme();

    // const [rowData, setRowData] = useState(data);
    // console.log("LineItemRow Service-->",rowData);
    // console.log("lineitemrow",data);
    const [expanded, setExpanded] = useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const handleRemove = (index) => {
        setIsRowRemoved(index)

    };
    const parseFieldValue = (field, value) => {
        // console.log(field)
        // console.log(field.name, field.type, field.value, isNumeric(field.value))
        if (field.type === 'decimal') {
            field.value = value.toString();
        }
        if (value !== '' && isNumeric(value) && field.name !== 'vat' && field.name !== 'product_id' && field.name !== 'name' && field.name !== "part_number" && field.name !== "description" && field.name !== "item_description") {

            // return field.value;
            // console.log(field.name, field.type)
            return format2Number(value);
        } else {
            return value;
        }
        // if (/<\/?[a-z][\s\S]*>/i.test(field.value) && view !== 'editview') {
        //     return parse(field.value);
        // }
    };
    const handleCheck = () => {
        return data.some(item => 'aos_products' === item.name);
    }
    return (
        <MuiThemeProvider theme={getMuiTheme(theme)}>

            <Grid container
                direction="row"
                justify="space-between"
                alignItems="center"
                spacing={1}
                className={classes.lineItemBox}
            >

                {data && data.map((field, fieldNum) => (
                    field.field_key !== "item_description" && field.field_key !== "description" ?
                        <Grid key={field.field_key} item sm='auto' xs={6} md={field.field_key === "name" || field.type === "relate" ? 2 : 1} >


                            <FormInput
                                field={field}
                                key={field.field_key}
                                //initialValues={initialValues}
                                value={
                                    // parseFieldValue(field) || ""
                                    parseFieldValue(field, initialValues[field.name] || '') || ""
                                }
                                readOnly={field.name === "product_total_price" || field.name === "vat_amt" || field.name === "product_unit_price" ? true : false}
                                small={true}
                                variant="standard"
                                //dynamicEnumValue={initialValues[field.parentenum] || ""}
                                module={module}
                                onChange={(val) => onChange(field, val, rowNum)
                                }
                            />
                        </Grid>
                        : null
                ))}
                <Grid item sm={1} md={1} xs={1}>
                    <IconButton size="small" aria-label="delete" onClick={() => handleRemove(rowNum)} className={classes.margin}>
                        <DeleteIcon />
                    </IconButton>
                    {handleCheck() ?
                        <IconButton size="small"
                            className={clsx(classes.expand, {
                                [classes.expandOpen]: expanded,
                            })}
                            onClick={handleExpandClick}
                            aria-expanded={expanded}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </IconButton>
                        : null}

                </Grid>
                {handleCheck() ?

                    <Grid container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        spacing={0}
                    >
                        <Collapse className={classes.collapseBox} in={expanded} timeout="auto" unmountOnExit>
                            <CardContent className={classes.collapseCardContent}>
                                <Grid container
                                    direction="row"
                                    justify="space-between"
                                    alignItems="center"
                                    spacing={1}
                                >

                                    {data && data.map((field, fieldNum) => (
                                        field.field_key === "item_description" || field.field_key === "description" ?

                                            <Grid key={field.field_key} item sm='auto' xs="6" md="6" >


                                                <FormInput
                                                    field={field}
                                                    //initialValues={initialValues}
                                                    value={
                                                        // parseFieldValue(field) || ""
                                                        parseFieldValue(field, initialValues[field.name] || '') || ""
                                                    }
                                                    small={true}
                                                    variant="standard"
                                                    //dynamicEnumValue={initialValues[field.parentenum] || ""}
                                                    module={module}
                                                    onChange={(val) => onChange(field, val, rowNum)
                                                    }
                                                    key={field.field_key}
                                                />
                                            </Grid>
                                            : null
                                    ))}
                                </Grid>

                            </CardContent>
                        </Collapse>


                    </Grid>
                    : null}
            </Grid>
        </MuiThemeProvider>
    );
};